import {
    SET_FILTERS
} from '../actions';

export function rowFilters(state = [], action = {}) {
    return action.type === SET_FILTERS ? Object.assign({}, action.payload) : state;
}


// WEBPACK FOOTER //
// ./src/reducers/reducers-datagrid.js